module.exports = require('react/lib/ReactComponentWithPureRenderMixin');


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react-addons-pure-render-mixin/index.js
 ** module id = 31
 ** module chunks = 1
 **/